import { render, staticRenderFns } from "./SimulatorExpressPage.vue?vue&type=template&id=5432a10e&scoped=true&"
import script from "./SimulatorExpressPage.vue?vue&type=script&lang=js&"
export * from "./SimulatorExpressPage.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorExpressPage.vue?vue&type=style&index=0&id=5432a10e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432a10e",
  null
  
)

export default component.exports